
import { Vue, Component } from 'vue-property-decorator'
import ProductProvider from '@/resources/product.provider'
import * as onScan from 'onscan.js'
import keyCodeMapperCharacter from '@/utils/keycodemap.utils'
import SizeValues from '@/utils/size-values.util'

const NoPicture = require('@/assets/no_picture_available.png')

const ProductService = new ProductProvider()

@Component
export default class ProductList extends Vue {
  // ====== data ======
  products: any[] = []

  query: any = {
    page: 1,
    limit: 15,
    sortBy: 'createdAt',
    sortOrder: 'desc',
    search: '',
    tags: [],
    tagOperation: 'OR',
    brand: 'all',
    collection: ''
  }

  noPicture = NoPicture

  totalPage = 1

  totalProduct = 0

  getting = false

  showNumberFormat!: any

  async searchProduct (searchType: string): Promise<void> {
    this.query.page = 1
    this.getting = false

    if (!this.query.search.trim()) {
      this.$buefy.toast.open({
        message: 'กรุณาระบุข้อมูลที่ต้องการค้นหา',
        type: 'is-danger'
      })
      this.products = []
      this.totalPage = 1
      this.totalProduct = 0
      return
    }
    if (this.query.search !== this.$route.query.search) {
      this.$router.replace({
        query: {
          search: this.query.search
        }
      })
    }

    this.products = []
    await this.fetchProducts()

    if (!this.products.length) {
      this.$buefy.toast.open({
        message: 'ไม่พบข้อมูลสินค้า',
        type: 'is-danger'
      })
      if (searchType === 'scan') {
        this.query.search = ''
      }
      return
    }
    if (
      searchType === 'typing'
      && this.query.search.split('.')?.length === 7
      && this.query.search.split('.')[6]
    ) {
      this.products = this.products.filter((p) => p.sku.code === this.query.search)
    }
    if (this.products.length && searchType === 'scan') {
      const matchedSku = this.products.find((p) => p.sku.code === this.query.search)
      if (matchedSku) {
        this.$router.push({
          name: 'ProductWeightAndDimensionUpdate',
          params: { skuId: matchedSku.sku.id }
        })
      }
    }
  }

  async fetchProducts (): Promise<void> {
    this.getting = true
    try {
      const { data } = await ProductService.getProductsInfo({
        page: this.query.page,
        limit: this.query.limit,
        search: this.query.search,
        tags: this.query.tags,
        tagOperation: this.query.tagOperation,
        brand: this.query.brand,
        collection: this.query.collection
      })

      this.totalPage = data.pages
      this.totalProduct = data.total
      this.products = data.results.flatMap(
        ({ skus, ...product }: any) => this.sortSize(skus).map((sku: any) => ({
          ...product,
          sku,
          weightGram: sku.weightGram ?? null,
          dimension: sku.dimension ?? {
            widthCm: null,
            lengthCm: null,
            heightCm: null
          }
        }))
      )
    } catch (error) {
      console.error('fetchProducts', error)
      this.$buefy.toast.open({ message: 'เกิดข้อผิดพลาด', type: 'is-danger' })
    } finally {
      this.getting = false
    }
  }

  // eslint-disable-next-line class-methods-use-this
  sortSize (skus: any[]): Array<any> {
    return [...skus].sort(
      (a, b) => SizeValues(a.size.name) - SizeValues(b.size.name)
    )
  }

  mounted (): void {
    if (this.$route.query.search) {
      this.query.search = this.$route.query.search
      this.searchProduct('typing')
    }
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const _this = this
    onScan.attachTo(document, {
        suffixKeyCodes: [13],
        reactToPaste: true,
        onScan (sCode) {
          const patternUrl = /^(https:\/\/www\.gentlewomanonline\.com\/|https:\/\/gentlewomanonline\.com\/|https:\/\/www\.matter-makers\.com\/|https:\/\/matter-makers\.com\/)/
          if (patternUrl.test(sCode.toLowerCase())) {
            const splitCodeFromUrl = sCode.split('/')
            const skuCode = splitCodeFromUrl[splitCodeFromUrl.length - 1]
            if (skuCode) {
              _this.query.search = skuCode
              _this.searchProduct('scan')
            } else {
              _this.$buefy.toast.open({ message: 'QRCODE ไม่สามารถใช้งานได้', type: 'is-danger' })
            }
          } else {
            _this.$buefy.toast.open({ message: 'QRCODE ไม่สามารถใช้งานได้', type: 'is-danger' })
          }
        },
        keyCodeMapper (oEvent: any) {
          if (keyCodeMapperCharacter[+oEvent.keyCode] !== undefined) {
            return keyCodeMapperCharacter[+oEvent.keyCode][+oEvent.shiftKey]
          }
          return onScan.decodeKeyEvent(oEvent)
        }
    })
  }

  // eslint-disable-next-line class-methods-use-this
  beforeDestroy (): void {
    onScan.detachFrom(document)
  }
}
